<script>
import Multiselect from "@vueform/multiselect";
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
// import MonitoraTable from './monitora-table'
import appConfig from "@/app.config";
import Swal from "sweetalert2"
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import animationJson from '@/assets/animations/monitoramento_anim.json'
import {exportDataGrid} from "devextreme/excel_exporter";
import {saveAs} from "file-saver-es";
import {Workbook} from "exceljs";
import {clientesChart1, clientesChart2 } from "../components/data-simulados";
import exportFromJSON from "export-from-json";
import moment from "moment/moment";

import {
  DxColumn,
  DxColumnChooser, DxColumnFixing,
  DxDataGrid,
  DxExport,
  DxFilterRow, DxGrouping, DxGroupPanel,
  DxPager,
  DxRemoteOperations, DxStateStoring,
  DxToolbar,
  DxItem,
  DxButton,
  DxPaging,
  DxSummary,
  DxTotalItem
} from "devextreme-vue/data-grid";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Monitoramento XML",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, Loader, Vue3Lottie, Multiselect,
    DxColumnFixing, DxStateStoring, DxGrouping, DxToolbar,
    DxItem, DxGroupPanel, DxColumn, DxDataGrid, DxExport, DxRemoteOperations,
    DxPager, DxFilterRow, DxButton, DxColumnChooser, DxPaging, DxSummary, DxTotalItem
   }, //MonitoraTable,

  data() {
    return {
      animationJson,
      title: 'Relatórios Financeiro',
      items: [
        {
          text: 'Financeiro',
          href: '/',
        },
        {
          text: 'Relatórios',
          active: true,
        },
      ],
      loadingList: true,
      loadingGraph: true,
      monitorasList: null,
      updating: false,
      periodo: null,
      periodoPesq: false,
      cliChart1: clientesChart1,
      cliChart2: clientesChart2,
      pesqTextFilter: '',
      statusFilter: 'T',
      dtBaseFiltro: 'DTEMI',
      dtIniFiltro: null,
      dtFimFiltro: null,
      relatselected: 'todos',
      dtListPesqEmpresas: [],
      empresasSelected: [],
      financeiroList: [],
      submittedPeriodo: false,
      tiporel: true,
      dtListPesqRepres: [],
      represSelected: [],
      dtListPesqBanco: [],
      bancoSelected: [],
    }
  },

  mounted() {
    console.log('mounted monitora-list_0')
    let dataAtu = new Date()
    const anoAtu = dataAtu.getFullYear()
    // const mesAtu = ("0" + (dataAtu.getMonth() + 1)).slice(-2)
    const mesAtu = ("0" + (dataAtu.getMonth())).slice(-2)
    // console.log(dataAtu.getFullYear())
    // console.log(dataAtu.getMonth())
    // console.log(mesAtu)
    // console.log(anoAtu)
    this.periodo = anoAtu + '-' + mesAtu
    this.atualizaDataList()
  },

  methods: {
    carregouGrid(e) {
      console.log("carregouGrid");
      console.log(e);
      /*if (this.orctoData.id === 0) {
        this.title = "Novo Orçamento";
      } else {
        this.title = `Editando Orçamento: ${this.orctoData.id}`;
      }*/
    },

    onExporting(e) {
      console.log("onExporting");
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("plan1");
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
              new Blob([buffer], { type: "application/octet-stream" }),
              this.title + ".xlsx"
          );
        });
      });
      e.cancel = true;
    },

    confirmaPeriodoPesq() {
      console.log('confirmaPeriodoPesq')

      localStorage.setItem('filtros', JSON.stringify({
        'tipoFilter': this.periodoPesq
      }))
    },

    confirmaTipoRel() {
      console.log('confirmaTipoRel')

      localStorage.setItem('filtros', JSON.stringify({
        'tiporel': this.tiporel
      }))

      this.atualizaDataList()
    },

    pesqEmpresa(evt){
      console.log('pesqEmpresa')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/emprepesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios emprepesq')
          console.log(JSON.stringify(res.data))
          
          this.dtListPesqEmpresas = res.data
        })
      }
    },

    pesqRepres(evt){
      console.log('pesqRepres')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/reprpesq`, {
          params: { q: query, t: 'S' }
        }).then((res) => {
          console.log('then axios reprpesq')
          console.log(res.data)

          this.dtListPesqRepres = res.data
        })
      }
    },

    pesqBanco(evt){
      console.log('pesqBanco')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/ccontapesq`, {
          params: { q: query, t: 'S' }
        }).then((res) => {
          console.log('then axios ccontapesq')
          console.log(res.data)

          this.dtListPesqBanco = res.data
        })
      }
    },

    escolheuEmpresa(evt){
      console.log('Empresas selecionadas atualmente:', JSON.stringify(this.empresasSelected));

      const existe = this.empresasSelected.find(item => {
        return item.id === evt
      })

      if (existe) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Empresa já selecionada!",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    escolheuRepres(evt){
      console.log('Representantes selecionados atualmente:', JSON.stringify(this.represSelected));

      const existe = this.represSelected.find(item => {
        return item.id === evt
      })

      if (existe) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Representante já selecionado!",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    escolheuBanco(evt){
      console.log('Bancos selecionados atualmente:', JSON.stringify(this.bancoSelected));

      const existe = this.bancoSelected.find(item => {
        return item.id === evt
      })

      if (existe) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Banco já selecionado!",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      const filtros = JSON.parse(localStorage.getItem('filtros')) || {};

      filtros.movdi = moment(this.dtIniFiltro).format('YYYY-MM-DD');
      filtros.movdf = moment(this.dtFimFiltro).format('YYYY-MM-DD');

      localStorage.setItem('filtros', JSON.stringify(filtros));
    
      this.atualizaDataList()
    },

    atualizaDataList() {
      const filtros = JSON.parse(localStorage.getItem("filtros"));

      if (!filtros) {
        console.log('cookie dataMov não existe, criando e definindo para o mês atual');
        let primeiroDiaMesAtual = moment().startOf('month').format('YYYY-MM-DD');
        let dataAtual = moment().format('YYYY-MM-DD');

        this.dtIniFiltro = primeiroDiaMesAtual;
        this.dtFimFiltro = dataAtual;

        localStorage.setItem(
          'filtros',
          JSON.stringify({
            movdi: primeiroDiaMesAtual,
            movdf: dataAtual,
          })
        );
      } else {
        this.dtIniFiltro = filtros['movdi'];
        this.dtFimFiltro = filtros['movdf'];

        if (!this.dtIniFiltro || !this.dtFimFiltro) {
            console.log('Filtros existentes, mas com datas nulas. Redefinindo para o mês atual.');
            let primeiroDiaMesAtual = moment().startOf('month').format('YYYY-MM-DD');
            let dataAtual = moment().format('YYYY-MM-DD');
            this.dtIniFiltro = primeiroDiaMesAtual;
            this.dtFimFiltro = dataAtual;
            localStorage.setItem(
                'filtros',
                JSON.stringify({
                    movdi: primeiroDiaMesAtual,
                    movdf: dataAtual,
                })
            );
        }
      }

      this.loadingList = true;
      api.get(`${getBaseUrl()}api/relfinanc`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter,
          'di': this.dtIniFiltro,
          'df': this.dtFimFiltro,
          'relatselected': this.relatselected,
          'empresasselected': this.empresasSelected,
          //'periodoPesq': this.periodoPesq,
          'tiporel': this.tiporel,
          'represSelected': this.represSelected,
          'bancoSelected': this.bancoSelected,
          'dtbasefiltro': this.dtBaseFiltro,
        }
      }).then((res) => {
        console.log('then axios');
        console.log(res.data[0]);
        this.title = `Relatórios Financeiro`;
        this.loadingList = false;
        this.financeiroList = res.data.data;
      }).catch((error) => {
        console.error('Erro na requisição:', error);
        this.loadingList = false;
      });
    },

    deletaReg(dataID) {
      console.log('deletaReg_pai dataID:')
      console.log(dataID)
      this.loadingList = true
      api.delete(`${getBaseUrl()}api/monitora`, {
        params: {
          'iddata': dataID
        }
      }).then((res) => {
        console.log('then axios delete')
        console.log(res.data)
        this.atualizaDataList()
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações excluídas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })
    },

    relEFDFiscal(){
      console.log('relEFDFiscal')
      console.log(this.periodo)
      console.log(typeof this.periodo)
      this.updating = true
      api.get(`${getBaseUrl()}api/efdfisc`, {
        params: {
          periodo: this.periodo
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.empresaData = res.data[0]
        const data = res.data[1]
        const fileName = "EFD_Fiscal_" + this.empresaData.fantasia + '_' + this.periodo;
        const exportType = exportFromJSON.types.txt;
        if (data) exportFromJSON({ data, fileName, exportType });
        this.updating = false
      });
    },

    relEFDPisCofins(){
      console.log('relEFDPisCofins')
      console.log(this.periodo)
      console.log(typeof this.periodo)
      this.updating = true
      api.get(`${getBaseUrl()}api/efdpiscof`).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.empresaData = res.data[0]
        const data = res.data
        const fileName = "EFD_PisCofins_" + this.empresaData.fantasia + '_' + this.periodo;
        const exportType = exportFromJSON.types.txt;
        if (data) exportFromJSON({ data, fileName, exportType });
        this.updating = false
      });
    },

    relResultados(){
      console.log('relResultados')
      console.log(this.periodo)
      console.log(typeof this.periodo)
      this.updating = true

      api.get(`${getBaseUrl()}api/relresults`, {
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_resultados_001.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.updating = false
      })

    },

    confirmaPesq() {
      console.log('titleTime')

      
    },


    mudouPeriodo(){
      console.log('mudouPeriodo')
      console.log(this.periodo)
      this.dtFimFiltro = new Date();
      this.dtIniFiltro = new Date();
      this.dtIniFiltro.setDate(this.dtIniFiltro.getDate() - this.periodo);

      console.log('Data Início do Filtro:', this.dtIniFiltro);
      console.log('Data Fim do Filtro:', this.dtFiltro);

    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDecimal(value){
      // console.log('format_value')
      // console.log('value')
      // console.log('typeof value')
      let value_n = parseFloat(value);
      return Number(value_n).toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 4});
    },


    nomeStatus(e) {
      switch (e.value) {
        case 'A':
          return 'Ativa(A)'
        case 'Q':
          return 'Quitado(Q)'
        case 'X':
          return 'Cancelado(X)'
      }

      return 'Não definido'
    },

    nomeStatusBaixa(baixa) {
      switch (baixa.value) {
        case 'EL':
          return 'Elaboração(EL)'
        case 'AB':
          return 'Em Aberto'
        case 'AG':
          return 'Agendado'
        case 'QT':
          return 'Quitado'
      }

      return baixa.value
    },

    nomeTipo(e) {
      switch (e.value) {
        case 'P':
          return 'Pagar'
        case 'R':
          return 'Receber'
      }

      return 'Não Definido'
    },

    refeFormTable() {
      console.log("refeFormTable");
      this.dataGrid.state(null);
    },

  },
}
</script>

<template>
  <Layout>


    <span class="float-end" style="z-index: 1000; position: absolute; top: 10px; right: 180px;">
      <Vue3Lottie :animationData="animationJson" :height="250" :width="250" />
    </span>

    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <div class="row mt-4" v-if="!updating" style="z-index: 2; position: relative;">
            <div class="col-sm-2">
              <div class="col-sm-12 text-muted">
                <h5>Selecione o Período do Relatório</h5>
              </div>
            </div>

            <div class="col-md-1 mt-0">
              <div class="search-box d-inline-block">
                <div class="position-relative">
                  <select
                      id="selectStatus"
                      v-model="statusFilter"
                      @change="atualizaDataList"
                      class="form-control select2-search-disable">
                    <option value="T" selected>Todos</option>
                    <option value="AB">Abertos</option>
                    <option value="QT">Quitados</option>
                    <option value="AG">Agendados</option>
                  </select>
                  <i class="bx bx-filter-alt search-icon"></i>
                </div>
              </div>
            </div>

            <div class="col-md-1 mt-0">
              <div class="search-box d-inline-block">
                <div class="position-relative">
                  <select
                      id="basefiltro"
                      v-model="dtBaseFiltro"
                      @change="atualizaDataList"
                      class="form-control select2-search-disable">
                    <option value="DTEMI" selected>dtEmissao</option>
                    <option value="DTVEN">dtVencimento</option>
                    <option v-if="tiporel === true" value="DTLIQ">dtLiquidez</option>
                  </select>
                  <i class="bx bx-calendar search-icon"></i>
                </div>
              </div>
            </div>

            <div class="col-sm-1 mx-0 mt-0"> <!--style="width: 150px"-->
              <label for="tipofinanceiro"> Tipo relatório </label>
              <div class="d-flex align-items-center justify-content-between" style="margin-top: -8px">
                <b-form-checkbox
                    id="tipofinanceiro"
                    switch
                    size="md"
                    @change="confirmaTipoRel"
                    v-model="tiporel">
                  {{ tiporel === true ? 'Detalhado' : 'Consolidado' }}
                </b-form-checkbox>
              </div>
            </div>

            <div class="row col-sm-8 text-start">
            </div>
          </div>

          <div class="row mt-4" v-if="!updating">
            <div class="row col-sm-2">
              <div class="col-sm-9" >
                <label for="relatselected">Tipo financeiro</label>
                <select id="relatselected" class="form-select border-muted rounded d-block w-100"
                        v-model="relatselected" style="padding: 6px 10px;">
                  <option value="receber">Receber</option>
                  <option value="pagar">Pagar</option>
                  <option value="todos">Consolidado(todos)</option>
                </select>
              </div>
            </div>

            <div class="row col-sm-9 text-start">
              <div v-if="periodoPesq === false" class="col-md-2 mb-3">
                <label for="dtIniFiltro">Dt. Início</label>
                <input
                  id="dtIniFiltro"
                  v-model="dtIniFiltro"
                  type="date"
                  class="form-control"
                  style="max-width: 200px;"
                  placeholder="Data Início"
                  :class="{'is-invalid': submittedPeriodo && !dtIniFiltro}"
                />
                <div v-if="submittedPeriodo && !dtIniFiltro" class="invalid-feedback">
                  <span>Campo data início obrigatório, favor preencher.</span>
                </div>
              </div>

              <div v-if="periodoPesq === false" class="col-md-2 mb-3">
                <label for="dtFimFiltro">Dt. Final</label>
                <input
                  id="dtFimFiltro"
                  v-model="dtFimFiltro"
                  type="date"
                  class="form-control"
                  style="max-width: 200px;"
                  placeholder="Data Final"
                  :class="{'is-invalid': submittedPeriodo && !dtFimFiltro}"
                />
                <div v-if="submittedPeriodo && !dtFimFiltro" class="invalid-feedback">
                  <span>Campo data final obrigatória, favor preencher.</span>
                </div>
              </div>

              <div class="col-md-1" >
              </div>

              <div class="col-md-2">
                <label for="empresa">Empresa(s)</label>
                <multiselect id="empresa"
                    @search-change="pesqEmpresa"
                    @select="escolheuEmpresa"
                    v-model="empresasSelected"
                    placeholder="Atual(usuário)"
                    :options="dtListPesqEmpresas"
                    :searchable="true"
                    mode="tags"
                    label="codigo"
                    track-by="id"
                    value-prop="id">
                    <template #option="slotProps">
                      <div class="row">
                        <div>
                          <span class="text-info">
                            {{ slotProps.option.codigo }}
                          </span>
                          <span class="mx-4" >
                          </span>
                        </div>
                        <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                          <span class="mx-4" >
                          </span>
                          <span class="mx-4" >
                          </span>
                          <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
                      </div>
                    </template>
                </multiselect>
              </div>

              <div class="col-md-2">
                <label for="representante">Representante(s)</label>
                <multiselect id="representante"
                             @search-change="pesqRepres"
                             @select="escolheuRepres"
                             v-model="represSelected"
                             placeholder="Pesquisar"
                             :options="dtListPesqRepres"
                             :searchable="true"
                             mode="tags"
                             label="codigo"
                             track-by="id"
                             value-prop="id">
                  <template #option="slotProps">
                    <div class="row">
                      <div>
                          <span class="text-info">
                            {{ slotProps.option.codigo }}
                          </span>
                        <span class="mx-4" >
                          </span>
                      </div>
                      <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                      <span class="mx-4" >
                          </span>
                      <span class="mx-4" >
                          </span>
                      <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
                    </div>
                  </template>
                </multiselect>
              </div>

              <div class="col-md-2">
                <label for="banco">Banco(s)</label>
                <multiselect id="banco"
                             @search-change="pesqBanco"
                             @select="escolheuBanco"
                             v-model="bancoSelected"
                             placeholder="Pesquisar"
                             :options="dtListPesqBanco"
                             :searchable="true"
                             mode="tags"
                             label="numero"
                             track-by="id"
                             value-prop="id">
                  <template #option="slotProps">
                    <div class="row">
                      <div>
                          <span class="text-info">
                            {{ slotProps.option.codigo }}
                          </span>
                        <span class="mx-4" >
                          </span>
                      </div>
                      <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                      <span class="mx-4" >
                          </span>
                      <span class="mx-4" >
                          </span>
                      <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
                    </div>
                  </template>
                </multiselect>
              </div>
            </div>

            <div class="row col-sm-1" style="margin-top: 26px;">
              <div>
                <b-button variant="primary" style="padding: 8px 50px" @click="confirmarPeriodo">
                  <i class="bx bx-search"></i>
                </b-button>
              </div>
            </div>
          </div>

            <Loader v-if="loadingList" style="min-height: 300px;">
            </Loader>
          </div>

          <div class="table-responsive mt-2">
            <div class="mt-4">
              <DxToolbar>
                <DxItem location="before" widget="dxButton">
                  <DxButton
                      icon="refresh"
                      hint="Redefinir formatação de tabela para padrão"
                      :on-click="refeFormTable"
                  />
                </DxItem>
              </DxToolbar>
            </div>

            <div class="mt-0" v-if="!updating">
              <DxDataGrid
                  ref="dataGridRefKey"
                  :data-source="financeiroList"
                  :show-borders="true"
                  :focused-row-enabled="true"
                  :keyExpr="'id'"
                  :column-auto-width="true"
                  :show-row-lines="true"
                  :allow-column-reordering="true"
                  :allow-column-resizing="true"
                  :row-alternation-enabled="true"
                  @content-ready="carregouGrid"
                  @exporting="onExporting"
              >
                <DxRemoteOperations
                    :filtering="true"
                    :paging="true"
                    :sorting="true"
                    :summary="false"
                    :grouping="false"
                    :group-paging="false"
                />

                <DxColumnChooser :enabled="true" />
                <DxColumnFixing :enabled="true" />
                <DxFilterRow :visible="false" />

                <DxExport
                    :enabled="true"
                    :allow-export-selected-data="true"
                />
                <DxStateStoring
                    :enabled="true"
                    type="sessionStorage"
                    storage-key="strWmsOsEntradaList"
                />

                <DxGroupPanel :visible="false" />
                <DxGrouping />

                <DxColumn
                    :width="60"
                    data-field="id"
                    caption="ID"
                    sort-order="desc"
                    data-type="number"
                    alignment="right"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"
                />

                <DxColumn
                    data-field="codigo"
                    caption="Código"
                    data-type="text"
                    alignment="right"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"
                />

                <DxColumn
                    data-field="numero"
                    caption="Número"
                    data-type="text"
                    alignment="right"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"
                />

                <DxColumn
                    data-field="nome_empresa"
                    caption="Empresa Nome"
                    data-type="text"
                    alignment="left"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"
                />

                <DxColumn
                    data-field="cnpj_empresa"
                    caption="Empresa Cnpj"
                    data-type="text"
                    alignment="right"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"
                />

                <DxColumn
                    data-field="nome_banco"
                    caption="Banco"
                    data-type="text"
                    alignment="right"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"
                />

                <DxColumn
                    data-field="tipo"
                    caption="Tipo"
                    data-type="text"
                    alignment="left"
                    :customize-text="nomeTipo"
                    :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                    :allow-sorting="false"
                    :allowHeaderFiltering="false"
                />

                <DxColumn
                    :width="180"
                    data-field="nome_pessoa"
                    caption="Cliente"
                    data-type="text"
                    alignment="left"
                    :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                    :allow-sorting="false"
                    :allowHeaderFiltering="false"
                />

                <DxColumn
                    data-field="cnpj_pessoa"
                    caption="Cliente Cnpj"
                    data-type="text"
                    alignment="right"
                    :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                    :allow-sorting="false"
                    :allowHeaderFiltering="false"
                />

                <DxColumn
                    data-field="stsbaixa"
                    caption="Status"
                    data-type="text"
                    alignment="center"
                    :customize-text="nomeStatusBaixa"
                    :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                    :allow-sorting="false"
                    :allowHeaderFiltering="false"
                />

                <DxColumn
                    data-field="nome_categoria"
                    caption="Categoria da Operação"
                    data-type="text"
                    alignment="left"
                    :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                    :allow-sorting="false"
                    :allowHeaderFiltering="false"
                />

                <DxColumn
                    data-field="nome_natureza"
                    caption="Natureza da Operação"
                    data-type="text"
                    alignment="left"
                    :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                    :allow-sorting="false"
                    :allowHeaderFiltering="false"
                />

                <DxColumn
                    data-field="nome_representante"
                    caption="Representante"
                    data-type="text"
                    alignment="right"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"
                />

                <DxColumn
                    data-field="formapgto"
                    caption="Forma Pgto"
                    data-type="text"
                    alignment="right"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"
                />

                <DxColumn
                    data-field="emissao"
                    caption="Dt. Emissao"
                    data-type="date"
                    alignment="right"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"
                />

                <DxColumn
                    data-field="vencimento"
                    caption="Vencimento"
                    data-type="date"
                    alignment="right"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"
                />

                <DxColumn
                    data-field="compet"
                    caption="Competência"
                    data-type="date"
                    alignment="right"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"
                />

<!--                <DxColumn
                    data-field="valorori"
                    caption="Valor Original"
                    data-type="number"
                    alignment="right"
                    :format="formatDecimal"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"
                />-->

                <DxColumn
                    data-field="valor"
                    caption="Valor"
                    data-type="number"
                    alignment="right"
                    :format="formatDecimal"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"
                />

                <DxColumn
                    data-field="valorabe"
                    caption="Valor em aberto"
                    data-type="number"
                    alignment="right"
                    :format="formatDecimal"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"
                />

                <DxColumn
                    data-field="valorqit"
                    caption="Valor quitado"
                    data-type="number"
                    alignment="right"
                    :format="formatDecimal"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"
                />

                <DxColumn
                    data-field="valordesc"
                    caption="Valor descontos"
                    data-type="number"
                    alignment="right"
                    :format="formatDecimal"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"
                />

                <DxColumn
                    data-field="valoracresc"
                    caption="Valor juros"
                    data-type="number"
                    alignment="right"
                    :format="formatDecimal"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"
                />

                <DxColumn
                    data-field="obs"
                    caption="Obs"
                    data-type="text"
                    alignment="left"
                    :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                    :allow-sorting="false"
                    :allowHeaderFiltering="false"
                />

                <DxSummary>
                  <DxTotalItem
                    column="valor"
                    summary-type="sum"
                    display-format="Total: {0}"
                  />

                  <DxTotalItem
                      column="valorabe"
                      summary-type="sum"
                      display-format="Total: {0}"
                  />

                  <DxTotalItem
                      column="valorqit"
                      summary-type="sum"
                      display-format="Total: {0}"
                  />

                </DxSummary>


                <DxPaging :page-size="10" />
                <DxPager
                    :show-page-size-selector="true"
                    :allowed-page-sizes="[10, 25, 50, 100]"
                    :show-navigation-buttons="true"
                    :show-info="true"
                />
              </DxDataGrid>
            </div>
          </div>

        </div>
      </div>
    </div>

  </Layout>
</template>

